import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlloxCommonAsyncPipe, IAlloxAsyncPipeIDNameList } from './allox-common-async.pipe';
import { DesignTemplate, DesignTemplateService } from '@app/core';


@Pipe({
    name: 'designTemplate', pure: false,
    standalone: false
})
export class DesignTemplatePipe
  extends AlloxCommonAsyncPipe<DesignTemplate>
  implements IAlloxAsyncPipeIDNameList<DesignTemplate>, PipeTransform {
  constructor(private service: DesignTemplateService, changeDetectorRef: ChangeDetectorRef, router: Router) {
    super(changeDetectorRef, router);
  }

  loadDependency() {
    return this.service.search();
  }
}
